<template>
  <LeistungenOverview page="fit" />
</template>

<script>
import LeistungenOverview from './leistungen-overview.vue';

export default {
  components: {
    LeistungenOverview,
  },
};
</script>
